import { v4 as uuidv4 } from 'uuid';
export class TemplateActivityModel {
    constructor() {
        this.activityId = uuidv4();
        this.activityDesc = '';
        this.isTenantVisible = false;
        this.baseline = 0;
        this.threshold = 0;
        this.displayOrder = 0;
    }
}
export default class TemplateActivity extends TemplateActivityModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
